import React from 'react';

import SelectButton from '../../../../design-system/SelectButton/SelectButton';
import JsonTextareaBox from '../../../../design-system/JsonTextareaBox/JsonTextareaBox';

const CycleStageForm = ({ stage, formData, handleInputChange, fieldErrorMessages, isEditable }) => {
    const { type, name, stage_status } = stage;
    const { status_key, status_label } = stage_status || {};

    return (
        <div className="flex flex-col gap-5">
            <div className="flex flex-col gap-5 pb-5 border-b border-neutral-200">
                <SelectButton
                    size="sm"
                    label="Cycle Stage"
                    isRequired
                    state="disabled"
                    selectedItem={{ id: type, name }}
                />

                <SelectButton
                    size="sm"
                    label="Current Status"
                    isRequired
                    state="disabled"
                    selectedItem={{ id: status_key, name: status_label }}
                />
            </div>

            <div className="flex flex-col gap-4">
                <JsonTextareaBox
                    mode="code"
                    value={formData.details}
                    setValue={(value) => handleInputChange('details', value)}
                    label="Stage Details"
                    isRequired
                    tipText="Configure the stage details."
                    state={
                        !isEditable ? 'disabled' : fieldErrorMessages.details ? 'error' : 'default'
                    }
                    errorMessage={fieldErrorMessages.details}
                    parentGap={16}
                    containerMinHeight={240}
                />
            </div>
        </div>
    );
};

export default CycleStageForm;
